import { Container, Col, Row } from "reactstrap";
import * as KeyQL from "queries/key";
import * as KeyAccess from "components/key-access";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import KeySchema from "@common/schema/keys/public";
import * as Section from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.keys"}
        query={KeyQL.list}
        variables={params}
        schema={KeySchema}
        target={{ $ref: "/Public/Key" }}
        empty={"No API keys yet."}
        widgets={KeyAccess.widgets}
        config={{
          "/Public/Key": {
            fields: ["description", KeyAccess.keyIdColumn, "createdAt"],
          },
        }}
        content={({ item: { keyId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${keyId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
